import { render, staticRenderFns } from "./StudyCalendarItem.vue?vue&type=template&id=03b72c33&scoped=true"
import script from "./StudyCalendarItem.vue?vue&type=script&lang=js"
export * from "./StudyCalendarItem.vue?vue&type=script&lang=js"
import style0 from "./StudyCalendarItem.vue?vue&type=style&index=0&id=03b72c33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b72c33",
  null
  
)

export default component.exports